import React, { useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { AppDispatch } from 'components/store/state/store'
import { useTranslation } from 'react-i18next'
import { updateCurrentStep } from 'components/core/state/actions'
import { ISetSearchParams } from 'components/core/types'
import Container from 'components/ui/Container'
import ucfirst from 'utils/ucfirst'

const mapDispatch = (dispatch: AppDispatch) => ({
  updateStep: (step: number, setSearchParams: ISetSearchParams) => {
    dispatch(updateCurrentStep(step, setSearchParams))
  },
})
const connector = connect(null, mapDispatch)

const Step4 = ({ updateStep }: ConnectedProps<typeof connector>) => {
  const [, setSearchParams] = useSearchParams()
  const { t } = useTranslation()
  useEffect(() => {
    setTimeout(() => updateStep(1, setSearchParams), 5000)
  }, [])
  return (
    <Container>
      <div className="tw-col-span-8 tw-col-start-2 xl:tw-col-span-12 xl:tw-col-start-1">
        <div className="tw-text-2xl md:tw-text-5xl tw-flex tw-justify-center tw-items-center tw-leading-normal">
          {ucfirst(t('step4.thank-you'))}
        </div>
      </div>
    </Container>
  )
}
export default connector(Step4)
